var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-autocomplete",
    _vm._b(
      {
        attrs: {
          items: _vm.domains,
          dense: "",
          name: _vm.name,
          "prepend-inner-icon": "",
          "error-messages": _vm.errorMessages,
          loading: _vm.loading
        },
        scopedSlots: _vm._u(
          [
            _vm.hasPrependIcon
              ? {
                  key: "prepend-inner",
                  fn: function fn() {
                    return [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            small: ""
                          }
                        },
                        [_vm._v(_vm._s(_vm.$attrs["prepend-inner-icon"]))]
                      )
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        ),
        model: {
          value: _vm.selected_domain,
          callback: function callback($$v) {
            _vm.selected_domain = $$v
          },
          expression: "selected_domain"
        }
      },
      "v-autocomplete",
      _vm.$attrs,
      false
    ),
    [
      !_vm.noLabel
        ? _c(
            "template",
            {
              slot: "label"
            },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }